import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import BaseAPI from './base.api';
import { type RuleNotifications } from 'types/notification.types';

dayjs.extend(utc);
dayjs.extend(timezone);

export default class NotificationAPI extends BaseAPI {
  getAllNotifications = async (
    timezoneBasedOnDisplayMode?: string
  ): Promise<RuleNotifications[]> => {
    let currentTime: string;
    if (timezoneBasedOnDisplayMode) {
      currentTime = dayjs().tz(timezoneBasedOnDisplayMode).toISOString();
    } else {
      currentTime = new Date().toISOString();
    }
    const response = await this.API.get('notification', {
      params: {
        currentTime,
      },
    });
    return response.data;
  };

  clearNotifications = async (payload: {
    notificationIds: string[];
  }): Promise<RuleNotifications[]> => {
    const response = await this.API.patch('notification/bulk/delete', payload);
    return response.data;
  };

  clearNotification = async (
    notificationId: string
  ): Promise<RuleNotifications[]> => {
    const response = await this.API.patch(
      `notification/${notificationId}/delete`
    );
    return response.data;
  };

  readNotification = async (
    notificationId: string,
    isRead: boolean
  ): Promise<RuleNotifications[]> => {
    const response = await this.API.patch(`notification/${notificationId}`, {
      isRead,
    });
    return response.data;
  };

  updateNotificationStatus = async (
    notificationId: string,
    isActive: boolean,
    note: string,
    source: 'notification' | 'leakage' = 'notification'
  ): Promise<RuleNotifications[]> => {
    const response = await this.API.patch(`notification/${notificationId}`, {
      isActive,
      note,
      source,
    });
    return response.data;
  };
}
